// src/wrapper/index.js
import React from 'react';                              // ← ❶ keep React in scope
import { useI18next } from 'gatsby-plugin-react-i18next';
import { ZoteTranslationProvider } from '@zoteapp/provider';

/** Small component whose *only* job is to run the hook */
function ZoteProviderBridge({ element }) {
  const { i18n } = useI18next();
  return (
    <ZoteTranslationProvider i18n={i18n}>
      {element}
    </ZoteTranslationProvider>
  );
}

/** Gatsby wrap-API: OK to use JSX here but no hooks */
export const wrapRootElement = ({ element }) => (
  <ZoteProviderBridge element={element} />
);
